import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../../lib/utils'

const fieldBase =
  'w-full rounded-2xl border border-input bg-background px-4 py-2.5 text-sm text-foreground shadow-sm transition-all duration-150 placeholder:text-muted-foreground hover:border-border focus:border-ring focus:outline-none focus:ring-2 focus:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60'

const fieldError = 'border-destructive hover:border-destructive focus:border-destructive focus:ring-destructive/25'

export function Input({
  id,
  label,
  error = null,
  className = '',
  inputClassName = '',
  disabled = false,
  endAdornment = null,
  ...props
}: {
  id?: string
  label?: string
  error?: string | null
  className?: string
  inputClassName?: string
  disabled?: boolean
  endAdornment?: ReactNode
} & ComponentProps<'input'>) {
  const inputEl = (
    <input
      id={id}
      disabled={disabled}
      className={cn(
        fieldBase,
        error && fieldError,
        endAdornment && 'pr-11',
        inputClassName,
      )}
      {...props}
    />
  )

  return (
    <div className={className}>
      {label ? (
        <label
          htmlFor={id}
          className={cn(
            'mb-2 block text-sm font-medium',
            disabled ? 'text-muted-foreground' : 'text-foreground',
          )}
        >
          {label}
        </label>
      ) : null}
      {endAdornment ? (
        <div className="relative">
          {inputEl}
          <div className="absolute inset-y-0 right-0 z-10 flex items-center pr-3">{endAdornment}</div>
        </div>
      ) : (
        inputEl
      )}
      {error ? <p className="mt-2 text-xs font-medium text-destructive">{error}</p> : null}
    </div>
  )
}
